import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const comparisons = [{
  feature: 'Setup Time',
  masterMerchant: '30 minutes',
  others: '2-4 weeks'
}, {
  feature: 'Setup Fees',
  masterMerchant: '$0',
  others: '$500-2,000'
}, {
  feature: 'Monthly Fees',
  masterMerchant: '$0',
  others: '$25-100/month'
}, {
  feature: 'Transaction Rate',
  masterMerchant: '2.5-2.9%',
  others: '2.9-3.5%'
}, {
  feature: 'Payout Speed',
  masterMerchant: 'Instant',
  others: '2-7 days'
}, {
  feature: 'Nonprofit-Owned',
  masterMerchant: true,
  others: false
}, {
  feature: '24/7 Support',
  masterMerchant: true,
  others: false
}, {
  feature: 'Hidden Fees',
  masterMerchant: false,
  others: true
}];
export function ComparisonSection() {
  return <section className="py-24 lg:py-32 bg-white" data-id="element-1">
      <div className="mx-auto max-w-5xl px-6 lg:px-8" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4" data-id="element-4">
            Why nonprofits choose us
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-5">
            We're not just better. We're built differently.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-gradient-to-br from-slate-50 to-white rounded-3xl border-2 border-slate-200 overflow-hidden" data-id="element-6">
          {/* Header */}
          <div className="grid grid-cols-3 gap-4 p-6 bg-slate-100 border-b border-slate-200" data-id="element-7">
            <div className="text-slate-600 font-medium" data-id="element-8">Feature</div>
            <div className="text-center" data-id="element-9">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-full font-semibold" data-id="element-10">
                Master Merchant
              </div>
            </div>
            <div className="text-center text-slate-600 font-medium" data-id="element-11">Others</div>
          </div>

          {/* Rows */}
          {comparisons.map((item, index) => <motion.div key={item.feature} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="grid grid-cols-3 gap-4 p-6 border-b border-slate-100 last:border-b-0 hover:bg-slate-50/50 transition-colors" data-id="element-12">
              <div className="font-medium text-slate-900" data-id="element-13">{item.feature}</div>
              <div className="text-center" data-id="element-14">
                {typeof item.masterMerchant === 'boolean' ? item.masterMerchant ? <div className="inline-flex w-8 h-8 rounded-full bg-green-100 items-center justify-center" data-id="element-15">
                      <CheckIcon className="w-5 h-5 text-green-600" data-id="element-16" />
                    </div> : <div className="inline-flex w-8 h-8 rounded-full bg-red-100 items-center justify-center" data-id="element-17">
                      <XIcon className="w-5 h-5 text-red-600" data-id="element-18" />
                    </div> : <span className="font-semibold text-slate-900" data-id="element-19">
                    {item.masterMerchant}
                  </span>}
              </div>
              <div className="text-center" data-id="element-20">
                {typeof item.others === 'boolean' ? item.others ? <div className="inline-flex w-8 h-8 rounded-full bg-green-100 items-center justify-center" data-id="element-21">
                      <CheckIcon className="w-5 h-5 text-green-600" data-id="element-22" />
                    </div> : <div className="inline-flex w-8 h-8 rounded-full bg-red-100 items-center justify-center" data-id="element-23">
                      <XIcon className="w-5 h-5 text-red-600" data-id="element-24" />
                    </div> : <span className="text-slate-600" data-id="element-25">{item.others}</span>}
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center mt-12" data-id="element-26">
          <button className="px-8 py-4 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-full font-semibold hover:shadow-xl hover:shadow-orange-500/30 transition-all" data-id="element-27">
            See the Difference Yourself
          </button>
        </motion.div>
      </div>
    </section>;
}